import React from 'react';
import {
  HomeOutlined as HomeIcon,
  PeopleOutline as GroupsIcon,
  ShowChart as ActivityIcon,
  PersonOutline as ProfileIcon,
} from '@mui/icons-material';

export type NavSection = 'dashboard' | 'groups' | 'activities' | 'profile';

export interface NavItem {
  key: NavSection;
  // Keys in the 'layout' namespace, resolved with t() at render so labels follow the language.
  labelKey: string;
  shortLabelKey: string;
  to: string;
  icon: React.ReactNode;
}

export const NAV_ITEMS: NavItem[] = [
  { key: 'dashboard', labelKey: 'nav.dashboard', shortLabelKey: 'nav.short.dashboard', to: '/', icon: <HomeIcon /> },
  { key: 'groups', labelKey: 'nav.groups', shortLabelKey: 'nav.short.groups', to: '/groups', icon: <GroupsIcon /> },
  { key: 'activities', labelKey: 'nav.activities', shortLabelKey: 'nav.short.activities', to: '/activities', icon: <ActivityIcon /> },
  { key: 'profile', labelKey: 'nav.profile', shortLabelKey: 'nav.short.profile', to: '/profile', icon: <ProfileIcon /> },
];

// Contests and teams live under a group, so they highlight the Groups entry.
export const sectionForPath = (path: string): NavSection | null => {
  if (path === '/') return 'dashboard';
  if (path.startsWith('/groups') || path.startsWith('/contests') || path.startsWith('/teams')) return 'groups';
  if (path.startsWith('/activities')) return 'activities';
  if (path.startsWith('/profile')) return 'profile';
  return null;
};
